import { useEffect, useState } from "react";

export type WindowSize = {
  height: number;
  width: number;
};

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0,
  });

  const changeWindowSize = () => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  };

  useEffect(() => {
    window.addEventListener("resize", changeWindowSize);
    changeWindowSize();

    return () => {
      window.removeEventListener("resize", changeWindowSize);
    };
  }, []);

  return windowSize;
};
export default useWindowSize;

export const useMinPageHeight = (): string => {
  const [minHeight, setMinHeight] = useState(0);
  const windowSize = useWindowSize();
  useEffect(() => {
    if (window && windowSize.height > 0) {
      const universalHeaderHeight =
        document?.getElementById("headerArea")?.getBoundingClientRect().height ?? 0;
      const universalFooterHeight =
        document?.getElementById("footerArea")?.getBoundingClientRect().height ?? 0;
      const windowHeight = window.innerHeight;
      setMinHeight(Math.floor(windowHeight - universalHeaderHeight - universalFooterHeight - 1));
    }
  }, [windowSize]);

  return `${minHeight}px`;
};

export const useIsDevOrStaging = (): boolean => {
  const [isValid, setIsValid] = useState(false);
  useEffect(() => {
    if (window) {
      setIsValid(
        window.location.origin === "https://lemon-staging.xbox.com" ||
          window.location.origin === "https://lemon-int-pme.xbox.com" ||
          window.location.origin === "https://onboarding.dev.microsoft.com:3000"
      );
    }
  }, []);
  return isValid;
};

export const useScrollToTopOnLoad = (skip?: boolean) => {
  useEffect(() => {
    if (!skip) {
      window.scrollTo(0, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
